import React, {useState, useEffect} from 'react';
import './styles/toggleSidebar.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faArrowLeft, faArrowUp, faArrowDown} from '@fortawesome/free-solid-svg-icons';

export default function ToggleSideBar({changeState, info}) {

  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    

    const changeWidth = () =>{
      setScreenWidth(window.innerWidth);
    }
    
    window.addEventListener('resize', changeWidth);

    return () => {
    
      window.addEventListener('resize', changeWidth);

    }


  }, [])


  return (
    <>
      {screenWidth < 900
        ? <>{info
          ? <button className='toggle-sidebar-box' onClick={changeState}><FontAwesomeIcon icon={faArrowDown} size='lg'/></button>
          : <button className='toggle-sidebar-box' onClick={changeState}><FontAwesomeIcon icon={faArrowUp} size='lg'/></button>
          }
        </>
        : <>{info
          ? <button className='toggle-sidebar-box' onClick={changeState}><FontAwesomeIcon icon={faArrowRight} size='lg'/></button>
          : <button className='toggle-sidebar-box' onClick={changeState}><FontAwesomeIcon icon={faArrowLeft} size='lg'/></button>
         }
        </>
      }  
    </>
  )
}
